<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="pl-4 pr-4" [formGroup]="form1">
  <p-fieldset styleClass="p-fluid " legend="Reservation Admin" [toggleable]="true" [collapsed]="true">
    <div class="p-formgrid grid">
      <div class="col-12">
        Global reservation admins for Rentals United.
      </div>
      <div class="flex justify-content-end mt-3">
        @if (formErrorMessage) {
          <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
        }
        <br>
          <button pButton type="button" class="p-button-danger" label="Sync All Reservations"
          (click)="onSyncAllReservations()"></button>
        </div>
      </div>
    </p-fieldset>
    <br>

      <p-fieldset styleClass="p-fluid " legend="Select Property" [toggleable]="true" [collapsed]="false">
        <div class="p-formgrid grid">
          <div class="col-12">
            <b>Select Property</b>
          </div>

          <div class="p-field col-12 mt-3">
            <span class="p-float-label">
              <p-dropdown [options]="shortTermRentals" formControlName="shortTermRentalId"
                optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="developmentId">Select Property</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small id="developmentId-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>



          <p-divider class="col-12 mt-3 mb-3"></p-divider>

          <div class="col-12 mb-2">
            <b>List Reservations</b>
          </div>

          <div class="p-field col-12 md:col-4 ">
            <span class="p-float-label">
              <p-calendar formControlName="startDate">
              </p-calendar>
              <label for="disabledays">From</label>
              @for (validation of validationMessages.startDate; track validation) {
                <span>
                  @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <p-calendar formControlName="endDate">
              </p-calendar>
              <label for="disabledays">To</label>
              @for (validation of validationMessages.endDate; track validation) {
                <span>
                  @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>



          <div class="p-field col-12">
            <div>
              @if (formErrorMessage) {
                <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
              }
              <button pButton class="p-button" type="button" style="width:200px;" label="List Reservations"
              (click)="onListReservations()"></button>
            </div>
          </div>

          <p-divider class="col-12 mt-3 mb-3"></p-divider>

          <div class="col-12 mb-2">
            <b>Update Reservation</b>
          </div>
          <div class="p-field col-12 md:col-4">
            @if (formErrorMessage) {
              <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
            }
            <button pButton class="p-button" type="button" style="width:200px;" label="Update Reservation"
            (click)="onFormSubmit()"></button>
          </div>
        </div>
      </p-fieldset>



      <br>
        <br>

          <h2>Reservations</h2>
          <p-table [value]="ruReservations">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="Date">Date <p-sortIcon field="Date"></p-sortIcon>
              </th>
              <th pSortableColumn="reservation.LastMod">Last Mod <p-sortIcon field="reservation.LastMod"></p-sortIcon>
            </th>
            <th pSortableColumn="reservation.ReservationID">RU ResId <p-sortIcon field="reservation.ReservationID">
            </p-sortIcon>
          </th>
          <th pSortableColumn="reservation.ReservationID">KBM ResId <p-sortIcon field="reservation.ReservationID">
          </p-sortIcon>
        </th>
        <th>RU PropId</th>
        <th>Arrival</th>
        <th>Departure</th>
        <th>Guests</th>
        <th pSortableColumn="reservation.CustomerInfo.SurName">Name <p-sortIcon
        field="reservation.CustomerInfo.SurName"></p-sortIcon>
      </th>
      <th>Total</th>
      <th pSortableColumn="reservation.Creator">CreatedBy <p-sortIcon field="reservation.Creator">
      </p-sortIcon>
    </th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-reservation>
  <tr>
    @if (reservation.StatusID==1) {
      <td style="background-color: lightgreen;">ACTIVE</td>
    }
    @if (reservation.StatusID==2) {
      <td style="background-color: darkred;">CANCELED</td>
    }
    @if (reservation.StatusID==3) {
      <td style="background-color: green;">MODIFIED</td>
    }
    <td>{{reservation.LastMod | date:'short'}}</td>
    <td><a [routerLink]=""
    (click)="onShowRuReservationJsonClick(reservation)">{{reservation.ReservationID}}</a></td>
    <td>{{reservation.ReservationID}}</td>
    <td>@for (StayInfo of reservation.StayInfos; track StayInfo) {
      <span>{{StayInfo.PropertyID}}</span>
    }</td>
    <td>@for (StayInfo of reservation.StayInfos; track StayInfo) {
      <span>{{StayInfo.DateFrom | date}} </span>
    }</td>
    <td>@for (StayInfo of reservation.StayInfos; track StayInfo) {
      <span>{{StayInfo.DateTo | date}} </span>
    }</td>
    <td>@for (StayInfo of reservation.StayInfos; track StayInfo) {
      <span>{{StayInfo.NumberOfGuests}} </span>
    }</td>
    <td>{{reservation.CustomerInfo.SurName}}</td>
    <td>@for (StayInfo of reservation.StayInfos; track StayInfo) {
      <span
        >{{StayInfo.ReservationBreakdown.RUBreakdown.Total | currency}}
      </span>
    }</td>
    <td>{{reservation.Creator}}</td>
  </tr>
</ng-template>
</p-table>
</div>